export function IntegrationSettings() {
  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-lg font-semibold text-gray-900 dark:text-white">
          Integration Settings
        </h2>
        <p className="text-sm text-muted-foreground">
          Manage your API integrations and data sources
        </p>
      </div>
      
      <div className="text-center py-12">
        <p className="text-muted-foreground">Integration settings coming soon...</p>
      </div>
    </div>
  )
}